import React from "react";

const ModalButton = ({handleModalStatus}) => {
    return(
        <div className="flex justify-end mt-4 mr-5">
            <button
                onClick={handleModalStatus}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold text-4xl  rounded-full shadow-lg w-16 h-16 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-200 ease-in-out"
            >
                +
            </button>
        </div>
    )
}

export default ModalButton